import { render, staticRenderFns } from "./AreaConfig.vue?vue&type=template&id=8e530248&"
import script from "./AreaConfig.vue?vue&type=script&lang=js&"
export * from "./AreaConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports